import styled, { css } from 'styled-components'

export const titleH3Css = css`
  font-size: 32px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.021em;
`

export const TitleH3 = styled.span`
  ${titleH3Css};
`

export const titleH4Css = css`
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  letter-spacing: -0.015em;
`

export const TitleH4 = styled.span`
  ${titleH4Css}
`

export const titleH5Css = css`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.012em;
`

export const TitleH5 = styled.span`
  ${titleH5Css};
`

export const TitleH7 = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
`

export const bodyLargeRegularCss = css`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.011em;
`

export const BodyLargeRegular = styled.span`
  ${bodyLargeRegularCss};
`

export const labelCss = css`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.16px;
`

export const LabelRegular = styled.span`
  ${labelCss}
`

export const labelSemiboldCss = css`
  ${labelCss}
  font-weight: 600;
`

export const LabelSemibold = styled.span`
  ${labelSemiboldCss};
`
export const buttonMediumCss = css`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.006em;
  text-align: center;
`
export const buttonLargeSemiboldCss = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.011em;
`

export const bodyShort02Css = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: -0.011em;
`

export const BodyShort02 = styled.span`
  ${bodyShort02Css}
`

export const bodyShortCss = css`
  font-size: 14px;
  line-height: 20px;
`

export const bodyShortBoldCss = css`
  ${bodyShortCss}
  font-weight: 600;
`

export const bodyMediumRegularCss = css`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.006em;
`

export const bodyMediumBoldCss = css`
  ${bodyMediumRegularCss}
  font-weight: 600;
`

export const BodyMediumRegular = styled.span`
  ${bodyMediumRegularCss}
`

export const BodyMediumBold = styled.span`
  ${bodyMediumBoldCss}
`

export const BodyShortBold = styled.span`
  ${bodyShortBoldCss}
`
